<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="订单号">
            <el-input
                v-model="formInline.out_trade_no"
                placeholder="订单号"
            ></el-input>
          </el-form-item>
          <el-form-item label="收货人">
            <el-input
                v-model="formInline.addressee"
                placeholder="收货人"
            ></el-input>
          </el-form-item>

          <el-form-item label="药房" v-if="isShow">
            <el-select
                v-model="formInline.provider_id"
                placeholder="药房"
                @change="providerChange"
            >
              <el-option
                  v-for="(child, index) in providerData"
                  :key="index"
                  :label="child.name"
                  :value="child.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="状态">
            <el-select
                v-model="formInline.status_id"
                placeholder="状态"
                @change="selectHandle"
            >
              <el-option
                  v-for="(child, index) in order_status"
                  :key="index"
                  :label="child.name"
                  :value="child.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <br/>
          <el-form-item label="物流号">
            <el-input
                v-model="formInline.express_no"
                placeholder="物流号"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
                v-model="formInline.phone"
                placeholder="手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="医生名">
            <el-input
                @focus="userFocus"
                v-model="formInline.doctor_name"
                placeholder="医生名"
            ></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
                class="handle-date mr10"
                v-model="formInline.date"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="dateChange()"
            >
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getData">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button
            type="primary"
            icon="el-icon-lx-down"
            class="handle-down"
            style="margin-bottom: 20px;"
            @click="handleExport"
        >批量导出
        </el-button>
      </div>
      <el-table
          :data="tableData"
          border
          class="table"
          ref="multipleTable"
          header-cell-class-name="table-header"
          v-loading="loading"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="out_trade_no"
            label="订单号"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="patient_name"
            label="患者"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="doctor_name"
            label="医生"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="addressee"
            label="收货人"
            align="center"
        ></el-table-column>
        <el-table-column label="支付时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.pay_at }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_time) }}
          </template>
        </el-table-column>
        <el-table-column label="药品类型" align="center">
          <template slot-scope="scope">
            {{ getIdName(provider_Status, scope.row.provider_type) }}
          </template>
        </el-table-column>

        <el-table-column
            prop="provider_name"
            label="供应商"
            align="center"
        ></el-table-column>
        <el-table-column label="订单状态" align="center">
          <template slot-scope="scope">
            {{ getIdNames(order_status, scope.row.status) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleLook(scope.row)"
            >详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
            background
            layout="prev, pager, next"
            :current-page="currentPage"
            :page-size="page_size"
            :page-count="totalPages"
            @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <div class="userInfo" v-show="userShow">
      <div class="userList">
        <div class="header">
          <h3>搜索用户</h3>
          <el-input
              v-model="formInline.doctor_name"
              placeholder="请输入医生姓名"
          ></el-input>
          <el-button type="primary" @click="searchUser">搜索</el-button>
        </div>
        <div class="tab">
          <el-table
              v-loading="loadings"
              :data="userData"
              border
              class="table"
              ref="usermultipleTable"
              header-cell-class-name="table-header"
              tooltip-effect="dark"
              @selection-change="handleUserSelectionChange"
          >
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column
                prop="id"
                label="医生ID"
                align="center"
            ></el-table-column>
            <el-table-column
                prop="name"
                label="姓名"
                align="center"
            ></el-table-column>
          </el-table>
          <el-pagination
              background
              layout="prev, pager, next"
              :current-page="userPage"
              :page-size="userPagepage_size"
              :page-count="userPagetotalPages"
              @size-change="sizeChange"
              @current-change="handleUserPageChange"
              :total="userPagetotalPages"
          ></el-pagination>
        </div>
        <div class="bot">
          <el-button type="" @click="cancelUser">取消</el-button>
          <el-button type="primary" @click="okUser">确认</el-button>
        </div>
      </div>
    </div>
    <div class="orderInfo" v-show="lookVisible" @click="closeLook" ref="box">
      <div class="order_detail" @click.stop="">
        <div class="order_details">
          <p style="height: 30px; font-weight: bold;font-size: 22px">
            订单详情
            <el-button
                v-show="printF"
                @click="closeLook"
                size="medium"
                type="primary"
                style="float: right;"
            >关闭
            </el-button>
          </p>
          <div class="patient_info">
            <span
            >订单号:{{
                JSON.stringify(detail) != "{}" ? detail.out_trade_no : ""
              }}</span
            >
            <span
            >处方单号:{{
                JSON.stringify(detail) != "{}" ? detail.prescription_num : ""
              }}</span
            >
            <span
            >下单时间:{{
                JSON.stringify(detail) != "{}"
                    ? formatDate(detail.created_time)
                    : ""
              }}</span
            >
          </div>
        </div>
        <div class="order_status" v-show="printF">
          <p style="height: 30px; font-weight: bold;font-size: 22px">
            {{
              JSON.stringify(detail) != "{}"
                  ? getIdNames(order_status, detail.status)
                  : ""
            }}
          </p>
          <div class="beizhustatus">
            <el-steps :active="actives" align-center>
              <el-step title="用户下单" icon="el-icon-circle-check"></el-step>
              <el-step title="用户付款" icon="el-icon-circle-check"></el-step>
              <el-step title="药房接单" icon="el-icon-circle-check"></el-step>
              <el-step title="药房发货" icon="el-icon-circle-check"></el-step>
              <el-step title="订单完成" icon="el-icon-circle-check"></el-step>
            </el-steps>
          </div>
        </div>
        <div class="medicinesInfo" v-show="printF">
          <p style="color:#2d8cf0">发货药房</p>
          <div class="medicines_info">
            <dl>
              <dt>
                <img
                    :src="
                    JSON.stringify(detail) != '{}'
                      ? detail.provider_info.logo
                      : ''
                  "
                    alt=""
                />
              </dt>
              <dd>
                <p>
                  {{
                    JSON.stringify(detail) != "{}"
                        ? detail.provider_info.name
                        : ""
                  }}
                </p>
                <p
                    v-if="
                    JSON.stringify(detail) != '{}'
                      ? detail.provider_info.type == 1
                      : false
                  "
                >
                  免煎颗粒
                </p>
                <p v-else>中药饮片</p>
              </dd>
            </dl>
          </div>
        </div>
        <div class="receiptInfo">
          <p style="color:#2d8cf0">收货信息</p>
          <div class="receipt_info">
            <p>
              {{ JSON.stringify(detail) != "{}" ? detail.addressee : "" }}
              {{ JSON.stringify(detail) != "{}" ? detail.phone : "" }}
            </p>
            <p>{{ JSON.stringify(detail) != "{}" ? detail.address : "" }}</p>
          </div>
        </div>
        <div class="prescriptionInfo">
          <p style="color:#2d8cf0">处方信息</p>
          <div class="prescription_info">
            <p>
              {{ JSON.stringify(detail) != "{}" ? detail.patient_name : "" }}
              {{
                JSON.stringify(detail) != "{}"
                    ? detail.patient_sex == 1
                    ? "男"
                    : "女"
                    : ""
              }}
              {{ JSON.stringify(detail) != "{}" ? detail.patient_age : "" }}岁
            </p>
            <p>
              <span
              >诊断：{{
                  JSON.stringify(detail) != "{}" ? detail.diseases : ""
                }}
                <span v-if="JSON.stringify(detail) != '{}' && detail.symptons"
                >·</span
                >
                {{
                  JSON.stringify(detail) != "{}" ? detail.symptons : ""
                }}</span
              >
            </p>
            <p><span>处方：</span></p>
            <p class="borderTie">{{ contents }}</p>
            <p>
              <span>帖数：</span
              >{{
                JSON.stringify(detail) != "{}" && detail.provider_info
                    ? detail.provider_info.total_count
                    : ""
              }}
              {{
                JSON.stringify(detail) != "{}" && detail.provider_info
                    ? detail.provider_info.prescription_type == 2
                    ? detail.is_process == 1
                        ? "代煎"
                        : detail.is_process == 2
                            ? "自煎"
                            : ""
                    : ""
                    : ""
              }}
            </p>
            <p
                v-if="
                (JSON.stringify(detail) != '{}' &&
                  detail.provider_info.prescription_type == 1) ||
                  (JSON.stringify(detail) != '{}' &&
                    detail.provider_info.prescription_type == 2)
              "
            >
              <span>用法：</span>
              <span>{{
                  JSON.stringify(detail) != "{}" && detail.provider_info
                      ? detail.provider_info.usage == 1
                      ? "内服；"
                      : "外用；"
                      : ""
                }}</span>
              <span
                  v-if="detail.provider_info && detail.provider_info.usage == 1"
              >{{
                  JSON.stringify(detail) != "{}" && detail.provider_info
                      ? "共" +
                      detail.provider_info.total_count +
                      "帖，每日" +
                      detail.provider_info.one_day_count +
                      "帖，一帖分" +
                      detail.provider_info.once +
                      "次服用"
                      : ""
                }}</span
              >
              <span
                  v-if="detail.provider_info && detail.provider_info.usage == 2"
              >{{
                  JSON.stringify(detail) != "{}" && detail.provider_info
                      ? "共" +
                      detail.provider_info.total_count +
                      "帖，每日" +
                      detail.provider_info.one_day_count +
                      "帖，一帖分" +
                      detail.provider_info.once +
                      "次使用"
                      : ""
                }}</span
              >
            </p>
            <p
                v-if="
                JSON.stringify(detail) != '{}' &&
                  detail.provider_info.prescription_type != 1 &&
                  detail.provider_info.prescription_type != 2
              "
            >
              <span>用法：</span>
              <!-- {{
                JSON.stringify(detail) != "{}" && detail.provider_info
                  ? "共" +
                    detail.provider_info.total_count +
                    "帖,每日" +
                    detail.provider_info.one_day_count +
                    "帖,一帖分" +
                    detail.provider_info.once +
                    "次服用"
                  : ""
              }} -->
            </p>

            <p>
              <span>医嘱：</span
              >{{
                JSON.stringify(detail) != "{}" && detail.provider_info
                    ? detail.provider_info.advice
                    : ""
              }}
            </p>
            <p>
              <span>医生姓名：</span
              >{{
                JSON.stringify(detail) != "{}" && detail.provider_info
                    ? detail.doctor_name
                    : ""
              }}
            </p>
          </div>
        </div>
        <div class="priceInfo" v-show="printF">
          <span
          >药房药品结算金额：{{
              JSON.stringify(detail) != "{}"
                  ? detail.provider_info.providers_drug_base_price
                  : ""
            }}</span
          ><br/>
          <span
              v-if="
              JSON.stringify(detail) != '{}' &&
                detail.provider_info.prescription_type == 2 &&
                detail.is_process == 2
            "
          >
            加工费：0
          </span>
          <span v-else>
            加工费：
            {{
              JSON.stringify(detail) != "{}"
                  ? detail.provider_info.processing_fee
                  : ""
            }}
          </span>
          <br/>
          <span
          >合计：{{
              JSON.stringify(detail) != "{}"
                  ? Number(detail.provider_info.providers_drug_base_price)
                  : ""
            }}</span
          ><br/>
          <!--          <span>服务费:{{ JSON.stringify(detail) != '{}' ? detail.provider_info.service_price : '' }}</span><br>-->
          <!--          <span>优惠:0</span><br>-->
          <!--          <span>运费:{{ JSON.stringify(detail) != '{}' ? detail.postage : '' }}</span><br>-->
          <!--          <span>是否包邮:是</span>-->
          <!--          <span style="font-size: 20px;font-weight: bold"><br>合计: <span style="color: red">{{ JSON.stringify(detail) != '{}' ? detail.price : '' }}</span></span>-->
        </div>
        <div class="medicinesInfo" v-show="!printF">
          <p style="color:#2d8cf0">发货药房</p>
          <div class="medicines_info">
            <dl>
              <dt>
                <img
                    :src="
                    JSON.stringify(detail) != '{}'
                      ? detail.provider_info.logo
                      : ''
                  "
                    alt=""
                />
              </dt>
              <dd>
                <p>
                  {{
                    JSON.stringify(detail) != "{}"
                        ? detail.provider_info.name
                        : ""
                  }}
                </p>
                <p
                    v-if="
                    JSON.stringify(detail) != '{}'
                      ? detail.provider_info.type == 1
                      : false
                  "
                >
                  免煎颗粒
                </p>
                <p v-else>中药饮片</p>
              </dd>
            </dl>
          </div>
        </div>
        <div class="logisticsInfo" v-if="detail.status == 3" v-show="printF">
          <p style="color:#2d8cf0">物流信息</p>
          <div class="logistics_info">
            <span
            >快递公司：{{
                JSON.stringify(detail) != "{}" ? detail.express_name : ""
              }}</span
            >
            <span
            >快递单号：{{
                JSON.stringify(detail) != "{}" ? detail.express_no : ""
              }}</span
            ><br/>
            <span
            >快递信息：{{
                JSON.stringify(detail) != "{}" ? detail.express_name : ""
              }}</span
            >
            <button
                @click="gosee"
                style="width: 100px;height: 40px;background: #66b1ff;border: 1px solid #66b1ff;color: #fff;border-radius: 3px"
                type="primary"
            >
              去查看
            </button>
          </div>
        </div>
        <div class="order_button" v-show="printF">
          <el-button
              type="primary"
              v-if="detail.status == 1 && detail.provider_info.provider_id == 7"
              @click="approved"
          >审核通过
          </el-button
          >
          <el-button type="primary" v-show="tdShow" @click="rejection"
          >退单
          </el-button
          >
          <br/>
          <el-button
              @click="print"
              type="primary"
              v-show="
              detail.status == 1 ||
                detail.status == 2 ||
                detail.status == 3 ||
                detail.status == 5 ||
                detail.status == 6
            "
          >
            打印药品订单
          </el-button>
          <el-button
              type="primary"
              @click="fahuo"
              v-show="detail.status == 2 && detail.provider_info.provider_id == 7"
          >发货
          </el-button
          >
          <el-button type="primary" @click="fahuo1" v-show="detail.status == 3"
          >修改快递信息
          </el-button
          >
          <br/>
          <el-button
              type="primary"
              @click="luru"
              v-show="
              detail.status == 1 || detail.status == 2 || detail.status == 3
            "
          >
            录入处方单号
          </el-button>
          <el-button
              type="primary"
              @click="daochu"
              v-show="
              detail.status == 1 || detail.status == 2 || detail.status == 3
            "
          >导出处方
          </el-button>
        </div>
      </div>
    </div>
    <div class="fahuoInfo" v-show="deliverShow" @click="deliverLook">
      <div class="fahuo" @click.stop="">
        <div class="fahuotop">
          <div class="faleft"></div>
          <div class="faCenter">
            发货
          </div>
          <div class="faright">
            <el-button size="mini" @click="deliverLook" type="primary"
            >关闭
            </el-button
            >
          </div>
        </div>
        <div class="fahuoCent">
          <div class="fatext">
            <span>*</span>
            <span>快递公司</span>
            <span>
              <el-input v-model="shunfen" placeholder="快递公司"></el-input>
            </span>
          </div>
          <div class="fatext">
            <span>*</span>
            <span>快递单号</span>
            <span>
              <el-input v-model="kuaidiinp" placeholder="快递单号"></el-input>
            </span>
          </div>
        </div>
        <div class="faok">
          <el-button @click="deliverOk" type="primary">确认</el-button>
          <el-button @click="deliverLook">取消</el-button>
        </div>
      </div>
    </div>
    <div class="fahuoInfo" v-show="deliverShow1" @click="deliverLook1">
      <div class="fahuo" @click.stop="">
        <div class="fahuotop">
          <div class="faleft"></div>
          <div class="faCenter">
            发货
          </div>
          <div class="faright">
            <el-button size="mini" @click="deliverLook1" type="primary"
            >关闭
            </el-button
            >
          </div>
        </div>
        <div class="fahuoCent">
          <div class="fatext">
            <span>*</span>
            <span>快递公司</span>
            <span>
              <el-input v-model="shunfen" placeholder="快递公司"></el-input>
            </span>
          </div>
          <div class="fatext">
            <span>*</span>
            <span>快递单号</span>
            <span>
              <el-input v-model="kuaidiinp" placeholder="快递单号"></el-input>
            </span>
          </div>
        </div>
        <div class="faok">
          <el-button @click="deliverOk1" type="primary">确认</el-button>
          <el-button @click="deliverLook1">取消</el-button>
        </div>
      </div>
    </div>
    <div class="fahuoInfo" v-show="chufangShow" @click="chufangLook">
      <div class="fahuo" @click.stop="">
        <div class="fahuotop">
          <div class="faleft"></div>
          <div class="faCenter">
            录入处方单
          </div>
          <div class="faright">
            <el-button size="mini" @click="chufangLook" type="primary"
            >关闭
            </el-button
            >
          </div>
        </div>
        <div class="fahuoCent">
          <div class="fatext">
            <span>*</span>
            <span>处方单号</span>
            <span>
              <el-input
                  v-model="prescription_num"
                  placeholder="处方单号"
              ></el-input>
            </span>
          </div>
        </div>
        <div class="faok">
          <el-button @click="chufangOk" type="primary">确认</el-button>
          <el-button @click="chufangLook">取消</el-button>
        </div>
      </div>
    </div>
    <print ref="prints" :detail="detail" v-show="false"/>
  </div>
</template>

<script>
import {_} from "vue-underscore";

const {export_json_to_excel} = require("../../../utils/Export2Excel.js");
import http from "../../../api/pontusApiConfig";
import http1 from "../../../api/dorisApiConfig";
import http2 from "../../../api/iapetusApiConfig";
import {saveAs} from "file-saver";
import print from "./print";

export default {

  components: {
    print,
  },

  data() {
    return {
      userShow: false,
      userPage: 1,
      userPagetotalPages: 1,
      userPagepage_size: 10,
      allData: [],
      userPhone: "",
      userName: "",
      userDatas: [],
      userIds: [],
      userNames: [],
      userData: [],
      loadings: false,
      tdShow: false,
      formInline: {
        doctor_name: "",
      },
      order_loading: false,
      date_value: [],
      date_types: [
        {name: "按天", id: "day"},
        {name: "按周", id: "week"},
        {name: "按月", id: "month"},
      ],
      date_id: "day",
      shunfen: "顺丰",
      kuaidiinp: "",
      statistics: [],
      dateStatistics: [],
      keyword: "",
      providers: [],
      providerData: [],
      provider_id: 2,
      order_status: [
        {name: "全部", id: ""},
        {name: "待支付", id: 0},
        {name: "已支付", id: 1},
        {name: "药房已接单", id: 2},
        {name: "配送中", id: 3},
        {name: "已签收/已完成", id: 4},
        {name: "已退款(药房退单)", id: 5},
        {name: "已退款(系统退单)", id: 6},
        {name: "已取消(超时未支付)", id: -2},
        {name: "已退款(超时未审核)", id: 8},
      ],
      provider_Status: [
        {name: "颗粒", id: 1},
        {name: "饮片", id: 2},
        {name: "成药", id: 3},
      ],
      status_id: "",
      tableData: [],
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      loading: false,
      lookVisible: false,
      deliverShow: false,
      deliverShow1: false,
      chufangShow: false,
      editVisible: false,
      detail: {},
      contents: "",
      prescription_num: "",
      data: "1243",
      form: {},
      rules: {
        prescription_num: [
          {required: true, message: "请填写处方号", trigger: "blur"},
        ],
      },
      examineVisible: false,
      examine_form: {},
      examine_rules: {
        remark: [{required: true, message: "请填写备注", trigger: "blur"}],
      },
      expressVisible: false,
      express_form: {},
      express_rules: {
        express_name: [
          {required: true, message: "请填写快递商", trigger: "blur"},
        ],
        express_no: [
          {required: true, message: "请填写快递号", trigger: "blur"},
        ],
      },
      printF: true,
      actives: 1,
      ziShow: false,
      isShow: false,
    };
  },
  created() {
    this.getData();
    this.getProviders();
  },
  mounted() {
    let t = window.location.href;
    if (t.indexOf("?t=1") != "-1") {
      this.ziShow = false;
    } else {
      this.ziShow = true;
    }
    if (
        localStorage.getItem("providers_id") &&
        localStorage.getItem("providers_id") == 0
    ) {
      this.isShow = true;
    }
    this.getStatisticsData();
    this.$refs.box.addEventListener("scroll", this.scroll);
  },
  methods: {
    searchUser() {
      this.loadings = true;
      let params = {
        keywords: this.formInline.doctor_name,
      };
      http2.get("admin/doctors/filter", {params: params}).then((res) => {
        if (res.data.status_code == 200) {
          this.loadings = false;
          this.userData = res.data.data;
          let allData = res.data.data;
          this.userData = allData.slice(
              (this.userPage - 1) * this.userPagepage_size,
              this.userPage * this.userPagepage_size
          );
          this.userPagetotalPages = allData.length;
        }
      });
    },
    //用户列表操作
    handleUserSelectionChange(val) {
      this.userDatas = val;
    },
    cancelUser() {
      this.userShow = false;
    },
    okUser() {
      this.userIds = [];
      this.userNames = [];
      for (let i = 0; i < this.userDatas.length; i++) {
        this.userIds.push(this.userDatas[i].id);
        this.userNames.push(this.userDatas[i].name);
      }
      this.formInline.doctor_name = this.userNames.toString();
      this.formInline.doctor_id = this.userIds.toString();
      this.userShow = false;
    },
    //查询用户
    userFocus() {
      this.userShow = true;
      this.searchUser();
      this.toggleSelection(this.userDatas);
    },
    //默认选中
    toggleSelection(rows) {
      setTimeout(() => {
        this.loadings = false;
        if (rows) {
          for (let i = 0; i < this.userData.length; i++) {
            for (let j = 0; j < this.userIds.length; j++) {
              if (this.userIds[j] == this.userData[i].id) {
                this.$nextTick(() => {
                  this.$refs.usermultipleTable.toggleRowSelection(
                      this.userData[i],
                      true
                  );
                });
              }
            }
          }
        }
      }, 1000);
    },
    handleUserPageChange(val) {
      this.userPage = val;
      this.searchUser();
      this.toggleSelection(this.userDatas);
    },
    sizeChange(val) {
      this.userPagepage_size = val;
      this.userPage = 1;
      this.searchUser();
    },
    getDoctorName() {
      let params = {
        keywords: this.formInline.doctor_name,
      };
      http2.get("admin/doctors/filter", {params: params}).then((res) => {
        if (res.data.status_code == 200) {
          this.formInline.doctor_id = res.data.data[0].id;
          this.getData();
          this.loading = false;
        }
      });
    },
    getProviders() {
      let that = this;
      that.loading = true;
      http1.get("admin/select_providers").then(function (res) {
        that.providerData = res.data.data;
        for (let i = 0; i < that.providerData.length; i++) {
          if (that.providerData[i].id == -1) {
            that.providerData.splice(0, 1);
          }
        }
        that.loading = false;
      });
    },
    providerChange(e) {
      this.formInline.provider_id = e;
    },
    dateChange() {
      this.formInline.begin_time = this.formInline.date[0];
      this.formInline.end_time = this.formInline.date[1];
    },
    handleExport() {
      let that = this;
      if (that.totalPages === 1) {
        let list = [];
        that.tableData.forEach((item) => {
          list.push({
            out_trade_no: item["out_trade_no"],
            patient_name: item["patient_name"],
            doctor_name: item["doctor_name"],
            addressee: item["addressee"],
            created_time: that.formatDate(item["created_time"]),
            provider_type: that.getIdName(
                that.provider_Status,
                item["provider_type"]
            ),
            status: that.getIdNames(that.order_status, item["status"]),
          });
        });
        that.export(list);
      } else {
        that.exportList();
      }
    },
    exportList() {
      let that = this;
      let params = {
        page: 1,
        page_size: that.totalPages * that.page_size,
      };
      if (that.keyword) {
        params["out_trade_no"] = that.keyword;
      }
      if (that.provider_id) {
        params["provider_id"] = that.provider_id;
      }
      if (that.status_id) {
        params["status"] = that.status_id;
      }
    },
    export(res) {
      require.ensure([], () => {
        const tHeader = [
          "订单号",
          "患者",
          "医生",
          "收货人",
          "支付时间",
          "药品类型",
          "供应商",
          "订单状态",
        ];
        const filterVal = [
          "out_trade_no",
          "patient_name",
          "doctor_name",
          "addressee",
          "created_time",
          "provider_type",
          "provider_name",
          "status",
        ];
        const data = this.formatJson(filterVal, res);
        export_json_to_excel(tHeader, data, "药品订单列表");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    getStatisticsData() {
      let that = this;
      that.order_loading = true;
    },
    getSex(id) {
      if (id === 0) {
        return "女";
      } else if (id === 1) {
        return "男";
      } else {
        return "";
      }
    },
    getUsage(id) {
      if (id === 1) {
        return "内服";
      } else if (id === 2) {
        return "外用";
      } else {
        return "";
      }
    },
    getJson(json) {
      if (json) {
        json = JSON.parse(json);
        let str = "";
        json.forEach((item, index) => {
          if (index == 0) {
            str = item["name"] + item["count"] + item["unit"];
          } else {
            str += "，" + item["name"] + item["count"] + item["unit"];
          }
        });
        return str;
      } else {
        return "";
      }
    },
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    formatPrice(price) {
      return price / 100;
    },
    getIdName(list, id) {
      let item = _.filter(list, function (selector) {
        return selector.id == id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getIdNames(list, id) {
      if (id != 0) {
        let item = _.filter(list, function (selector) {
          return selector.id == id;
        })[0];
        if (item) {
          return item["name"];
        } else {
          return "";
        }
      } else if (id == 0) {
        return "待支付";
      }
    },
    getData() {
      this.loading = true;
      if (this.formInline.doctor_name == "") {
        this.formInline.doctor_id = "";
      }
      let params = {
        page: this.currentPage,
        page_szie: this.page_size,
        out_trade_no: this.formInline.out_trade_no,
        status: this.formInline.status_id,
        provider_id: this.formInline.provider_id,
        addressee: this.formInline.addressee,
        express_no: this.formInline.express_no,
        phone: this.formInline.phone,
        doctor_id: this.formInline.doctor_id,
        begin_time: this.formInline.begin_time,
        end_time: this.formInline.end_time,
      };
      http.get("admin/medshop/orders", {params: params}).then((res) => {
        if (res.data.status_code == 200) {
          this.tableData = res.data.data.orders;
          this.currentPage = parseInt(res.data.data.current_page);
          this.totalPages = res.data.data.total_pages;
          this.loading = false;
        } else {
          this.loading = false;
          this.$message.error(res.data.msg);
        }
      });
    },
    //选择
    selectHandle() {
    },
    // 触发搜索按钮
    handleSearch() {
      this.currentPage = 1;
      this.getData();
    },
    onInput() {
      this.$forceUpdate();
    },
    handleLook(row) {
      this.row = row;
      this.lookVisible = true;
      let params = {
        out_trade_no: row.out_trade_no,
      };
      http.get("admin/medshop/order", {params: params}).then((res) => {
        this.detail = res.data.data;
        this.$emit('value-updated', res.data.data); // 触发自定义事件，并传递新的值给子组件
        if (this.detail.provider_info.provider_id == 3) {
          if (
              this.detail.status == 1 ||
              this.detail.status == 2 ||
              this.detail.status == 3
          ) {
            this.tdShow = true;
          }
        }
        if (this.detail.provider_info.provider_id == 4) {
          if (
              this.detail.status == 1 ||
              this.detail.status == 2 ||
              this.detail.status == 3
          ) {
            this.tdShow = true;
          }
        }
        if (this.detail.provider_info.provider_id == 7) {
          if (this.detail.status == 1) {
            this.tdShow = true;
          }
        }
        this.actives =
            res.data.data.status == -1 ||
            res.data.data.status == -2 ||
            res.data.data.status == 0
                ? 1
                : res.data.data.status + 1;

        let data = JSON.parse(res.data.data.provider_info.content);
        let str = [];
        for (let i = 0; i < data.length; i++) {
          str.push(
              data[i].name +
              (data[i].usage ? "(" + data[i].usage + ")" : "") +
              data[i].count +
              data[i].unit +
              (data[i].signature && data[i].signature != ""
                  ? "[" + data[i].signature + "]"
                  : "")
          );
        }
        this.contents = str.toString();
      });
    },
    gosee() {
      let nu = this.detail.express_no;
      let com = this.detail.express_name ? this.detail.express_name : "顺丰";
      window.open(
          `https://m.kuaidi100.com/app/query/?com=` +
          com +
          `&nu=` +
          nu +
          `&coname=family`
      );
    },
    //审核通过
    approved() {
      this.$confirm("确定审核通过吗？", "提示", {
        type: "warning",
      })
          .then(() => {
            //console.log(this.detail);
            http
                .post("admin/medshop/approved", {
                  out_trade_no: this.detail.out_trade_no,
                })
                .then((res) => {
                  if (res.data.status_code == 200) {
                    this.$message.success("审核通过");
                    this.handleLook(this.row);
                  } else {
                    this.$message.error(res.data.msg);
                  }
                });
          })
          .catch(() => {
          });
    },
    //退单
    rejection() {
      // 二次确认删除
      //
      this.$confirm("确定要退单吗？", "提示", {
        type: "warning",
      })
          .then(() => {
            http
                .post("admin/medshop/rejection", {
                  out_trade_no: this.detail.out_trade_no,
                })
                .then((res) => {
                  if (res.data.status_code == 200) {
                    this.$message.success("退单成功");
                    this.handleLook(this.row);
                  } else {
                    this.$message.error(res.data.msg);
                  }
                });
          })
          .catch(() => {
          });
    },
    scroll() {
      let scroll = this.$refs.box.scrollTop;
      console.log(scroll);
    },
    //打印
    print() {
      const printContent = this.$refs.prints.$el.innerHTML;
      const printWindow = window.open('', '_blank');
      printWindow.document.open();
      //console.log(printContent);
      printWindow.document.write(`
        <html>
          <head>
            <title>打印</title>
          </head>
     <style>
* {
    margin: 0;
    padding: 0;
}
.print {
    width: 750px;
    height: auto;
    padding: 36px 41px;
    box-sizing: border-box;
    background: #fff;
}
.title {
    width: 100%;
    height: 58px;
}
.dl1 {
    float: left;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.dl1 img {
    width: 58px;
    height: 58px;
}
.dl1 dd {
    margin-left: 7px;
}
.dl1 dd p:nth-child(1) {
    font-size: 23px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #121212;
}
.dl1 dd p:nth-child(2) {
    font-size: 10px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 400;
    color: #121212;
}
.dl2 {
    float: right;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 9px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}
.dl2 p{
    font-size: 9px;
}
.dl2 img {
    width: 46px;
    height: 46px;
}
.dl3 {
    margin-right: 24px;
    float: right;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 9px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}
.dl3 p{
    font-size: 9px;
}
.dl3 img {
    width: 46px;
    height: 46px;
}
.print_order_info {
    margin-top: 10px;
    padding-top: 14px;
    padding-bottom: 14px;
    width: 100%;
    border-top: 1px solid #E4E4E4;
    display: flex;
    flex-direction: column;
}
.info_tag {
    width: 100%;
    height: 20px;
    padding-left: 10px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #333333;
    border-left: 3px solid #333333;
    line-height: 20px;
}
.info_text {
    flex: 1;
    margin-top: 13px;
}
.info_address {
    width: 302px;
    height: auto;
    float: left;
}
.address1 {
    padding-left: 10px;
    box-sizing: border-box;
    width: 100%;
    height: 32px;
    background: #FAFAFA;
    display: flex;
    justify-content: left;
    align-items: center;
    border-bottom: 1px solid #e4e4e4;
    font-size: 11px;
}
.address1 div {
    width: 65px;
    height: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
    font-size: 11px;
}
.address {
    padding-left: 10px;
    box-sizing: border-box;
    width: 100%;
    height: 32px;
    display: flex;
    justify-content: left;
    align-items: center;
    border-bottom: 1px solid #e4e4e4;
    font-size: 11px;
}
.address div {
    width: 65px;
    height: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
    font-size: 11px;
}
.info_order {
    width: 302px;
    height: auto;
    float: right;
}
.address1 {
    padding-left: 10px;
    box-sizing: border-box;
    width: 100%;
    height: 32px;
    background: #FAFAFA;
    display: flex;
    justify-content: left;
    align-items: center;
    border-bottom: 1px solid #e4e4e4;

}
.address1 div {
    width: 65px;
    height: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
}
.address {
    padding-left: 10px;
    box-sizing: border-box;
    width: 100%;
    height: 32px;
    display: flex;
    justify-content: left;
    align-items: center;
    border-bottom: 1px solid #e4e4e4;
}
.address div {
    width: 65px;
    height: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
}
.print_prescription_info {
    margin-top: 14px;
    width: 100%;
    display: flex;
    flex-direction: column;
}
.info_tag {
    width: 100%;
    height: 20px;
    padding-left: 10px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    border-left: 3px solid #333333;
    line-height: 20px;
}
.prescription_text {
    width: 100%;
    height: auto;
    margin-top: 10px;
}
.prescription_info1 {
    width: 100%;
    height: 32px;
    background: #FAFAFA;
    display: flex;

}
.prescription_li {

    width: 33%;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 11px;

}
.prescription_li div {
    width: 65px;
    padding-left: 15px;
}
.prescription_zd {
    width: 100%;
    display: flex;
    align-items: center;
    height: 32px;
    font-size: 11px;
}
.prescription_zd div {
    width: 65px;
    padding-left: 15px;
}
.pharmacy_info {
    width: 100%;
    height: auto;
    margin-top: 30px;
}
.pharmacy_name {
    width: 100%;
    height: 40px;
    background: #FAFAFA;
    line-height: 40px;
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #121212;
    padding-left: 13px;
    box-sizing: border-box;
}
.pharmacy_name span {
    margin-left: 23px;
    font-size: 11px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #AC4B38;
}
.pharmacy_drug {
    width: 100%;
    height: auto;
    border: 1px solid #e4e4e4;
}
.pharmacy_drug p {
    font-size: 11px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #121212;
    margin-top: 14px;
    margin-left: 14px;
    box-sizing: border-box;
}
.drug_ul {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
}
.drug_li {
    width: 147px;
    height: 42px;
    background: #FAFAFA;
    margin-left: 14px;
    margin-top: 14px;
    box-sizing: border-box;
    font-size: 11px;
}
.drug_li p{
    font-size: 11px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #121212;
    margin-top: 4px;
    margin-left: 7px;
}
.drug_li p:nth-child(2) span{
    padding-right: 5px;
    box-sizing: border-box;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}
.span11{
    float: left;
}
.span22{
    float: right;
}
.usage {
    width: 100%;
    height: auto;
}
.usage1 {
    width: 100%;
    height: 32px;
    line-height: 32px;
    display: flex;
    border: 1px solid #e4e4e4;
    font-size: 11px;
}
.usage1 div {
    width: 65px;
    padding-left: 15px;
    box-sizing: border-box;
}
.usage2 {
    width: 100%;
    height: 32px;
    line-height: 32px;
    display: flex;
    border: 1px solid #e4e4e4;
font-size: 11px;
}
.usage2 div {
    width: 65px;
    padding-left: 15px;
    box-sizing: border-box;
}
.doctor {
    width: 100%;
    height: 32px;
    line-height: 32px;
    background: #FAFAFA;
    display: flex;
    justify-content: right;
    padding-right: 10px;
    box-sizing: border-box;
    border: 1px solid #e4e4e4;
    font-size: 11px;
}
.doctor div {
    width: 65px;
    padding-left: 15px;
}

</style>
          <body>
            ${printContent}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    },
    closeLook() {
      this.lookVisible = false;
    },
    deliverLook() {
      this.deliverShow = false;
    },
    deliverLook1() {
      this.deliverShow1 = false;
    },
    luru() {
      this.chufangShow = true;
    },
    fahuo() {
      this.deliverShow = true;
    },
    fahuo1() {
      this.deliverShow1 = true;
    },
    chufangLook() {
      //console.log("处方");
      this.chufangShow = false;
    },
    daochu() {
      let sex = this.detail.patient_sex == 1 ? "男" : "女";
      const strData =
          `
      ----导出订单---
订单详情
订单号：` +
          this.detail.out_trade_no +
          `,下单时间:` +
          this.formatDate(this.detail.created_time) +
          `
处方信息
患者名称` +
          this.detail.patient_name +
          `,患者性别:` +
          sex +
          `,患者年龄` +
          this.detail.patient_age +
          `
诊断：咳嗽•风寒袭肺
处方：免煎颗粒（共7味药）
` +
          this.contents +
          `
帖数：共` +
          this.detail.provider_info.total_count +
          `帖
用法：` +
          this.detail.provider_info.advice +
          `。共` +
          this.detail.provider_info.total_count +
          `帖，每日` +
          this.detail.provider_info.one_day_count +
          `帖，一帖分` +
          this.detail.provider_info.once +
          `次服用
医生姓名：` +
          this.detail.doctor_name +
          `

药房药品结算金额：` +
          this.detail.provider_info.providers_drug_base_price +
          `
是否包邮：是

收货信息
` +
          this.detail.addressee +
          ` ` +
          this.detail.phone +
          `
` +
          this.detail.address +
          `
      `;
      const result = new Blob([strData], {type: "text/plain;charset=utf-8"});
      // 导出
      saveAs(result, `导出处方.txt`);
    },
    chufangOk() {
      let data = {
        out_trade_no: this.detail.out_trade_no,
        prescription_num: this.prescription_num,
      };
      http.post("admin/medshop/prescription/num", data).then((res) => {
        if (res.data.status_code == 200) {
          this.$message.success("录入成功");
          this.handleLook(this.row);
          this.chufangLook();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    deliverOk() {
      // 二次确认删除
      //
      this.$confirm("确定要发货吗？", "提示", {
        type: "warning",
      })
          .then(() => {
            let data = {
              out_trade_no: this.detail.out_trade_no,
              express_name: this.shunfen,
              express_no: this.kuaidiinp,
            };
            http.post("admin/medshop/deal_express", data).then((res) => {
              if (res.data.status_code == 200) {
                this.$message.success("发货成功");
                this.handleLook(this.row);
                this.deliverLook();
              } else {
                this.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {
          });
    },
    deliverOk1() {
      this.$confirm("确定要修改吗？", "提示", {
        type: "warning",
      })
          .then(() => {
            let data = {
              out_trade_no: this.detail.out_trade_no,
              express_name: this.shunfen,
              express_no: this.kuaidiinp,
            };
            http.post("admin/medshop/set_express_info", data).then((res) => {
              if (res.data.status_code == 200) {
                this.$message.success("修改成功");
                this.handleLook(this.row);
                this.deliverLook1();
              } else {
                this.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {
          });
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getData();
    },
    handleExamine(adopt, row) {
      console.log(adopt, row);
    },
    saveExamine(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.examineVisible = false;
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    handleExpress(row) {
      this.express_form = {
        out_trade_no: row.out_trade_no,
      };
      this.expressVisible = true;
    },
    saveExpress(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.expressVisible = false;
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    handleEdit(row) {
      this.form = {
        out_trade_no: row.out_trade_no,
        prescription_num: row.prescription_num,
      };
      this.editVisible = true;
    },
    saveEdit(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.editVisible = false;
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" type="text/css" scoped>
.userInfo {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;

  .userList {
    border: 1px solid #ccc;
    width: 1000px;
    height: 660px;
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .header {
    width: 100%;
    height: 80px;
    background: #fff;
    margin-bottom: 10px;
  }

  .header h3 {
    width: 100%;
    height: 35px;
  }

  .header .el-input {
    width: 200px;
    margin-right: 20px;
  }

  .tab {
    flex: 1;
  }

  .bot {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 180px;
}

.self-dialog-footer {
  display: block;
  text-align: center;
}

.avatar {
  height: 178px;
  display: block;
  max-width: 100%;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.fl {
  float: left;
  display: inline;
}

.fr {
  float: right;
  display: inline;
}

.medicines-ul {
  margin-top: 5px;
}

.medicines-ul .li,
.select-medicines-ul li {
  list-style-type: none;
}

.medicines-li {
  margin-right: 5px;
  margin-bottom: 5px;
  display: block;
  max-width: 100%;
  height: 30px;
  line-height: 20px;
  box-sizing: border-box;
  color: #333;
  text-align: center;
  font-size: 14px;
  padding: 5px;
  border: 1px solid #eee;
  border-radius: 6px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
}

.select-medicines-ul {
  width: 100%;
  min-height: 200px;
}

.select-medicines-li {
  margin-top: 10px;
  width: 33.333333%;
  box-sizing: border-box;
  padding-left: 25px;
  padding-right: 100px;
  position: relative;
}

.delete-medicine {
  width: 20px;
  height: 20px;
  padding: 3px;
  margin: auto;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
}

.medicine-name {
  display: block;
  width: 100%;
  height: 32px;
  line-height: 32px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.medicine-input {
  width: 50px;
  height: 32px;
  line-height: 32px;
  display: block;
  text-align: center;
  position: absolute;
  right: 50px;
  top: 0;
}

.medicine-input .el-input__inner {
  text-align: center;
}

.medicine-unit {
  display: block;
  height: 32px;
  line-height: 32px;
  position: absolute;
  right: 30px;
  top: 0;
}
</style>
<style scoped lang="scss">
@media print {
  @page {
    size: A4;
    margin: 0;
  }

  body {
    margin: 0;
    padding: 0;
  }
}
</style>